import { atom, useAtom } from "jotai";

import { getDefaultOpenOrders } from "#/config/openOrders";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { type Market } from "#/types/markets";
import { type OpenOrdersByPairs } from "#/types/orders";

import { useAccount } from "./account";

export const openOrdersAtom = atom<OpenOrdersByPairs>(getDefaultOpenOrders());

export const useOpenOrders = (market?: Market) => {
  const [openOrders, setOpenOrders] = useAtom(openOrdersAtom);

  const { account } = useAccount();
  const { market: positionDrawerMarket } = usePositionsDrawerMarket();

  const orders = account
    ? openOrders[market?.pair ?? positionDrawerMarket.pair]
    : [];
  const optionOpenOrders = orders.filter((order) => order.isOption);
  const perpOpenOrders = orders.filter((order) => !order.isOption);

  return {
    openOrders: orders,
    optionOpenOrders,
    perpOpenOrders,
    setOpenOrders,
  };
};
